<template>
   <div class="page-table-layout" data-testid="infomanager-new">
    <v-card :loading="loading" class="all-width flex-card shadow-off" :disabled="loading" loader-height="2" data-testid="infomanager-new__main-card">
        <v-card-text class="page-table-layout__body" data-testid="infomanager-new__main-content">
          <div class="d-flex align-center justify-space-between" data-testid="infomanager-new__header-bar">
            <div class="d-flex align-center" data-testid="infomanager-new__header-title-group">
              <h3 class="ma-0 black--text font-weight-semibold" data-testid="infomanager-new__header-title">Information Manager</h3>
              <v-tooltip bottom content-class="tooltip-bottom" >
                <template v-slot:activator="{ on, attrs }"> 
                    <v-btn 
                        v-bind="attrs"
                        v-on="on"
                        class="shadow-off ml-1" icon @click="refreshData()" data-testid="infomanager-new__refresh-btn"><v-icon
                        size="24" data-testid="infomanager-new__refresh-icon">mdi-refresh</v-icon>
                    </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>
              <activity-log
                      :resource-id="clientID" 
                      data-testid="infomanager-new__datatable-activity-log-btn"
                      row-description="Information Manager"
                      :type="$options.ACTIVITY_LOG_TYPES.MASTER_IM"  
                  />
            </div>
            <div class="d-flex align-center ma-0" data-testid="infomanager-new__header-action-group">
                <bulkPBCUpload @reload="refreshData()" :checklist="checklist" :info-owners="infoOwners" v-if="$nova.hasRight(right, 'add')" data-testid="infomanager-new__bulk-upload"/>
                <v-btn  color="primary" class="mr-1 px-4" 
                   @click="addRequirement()"
                     v-if="$nova.hasRight(right, 'add')" data-testid="infomanager-new__add-btn">
                <v-icon class="pr-2" data-testid="infomanager-new__add-icon">mdi-plus</v-icon>
                <span class="text-capitalize"><span data-testid="infomanager-new__add-label">New Requirement</span></span>
              </v-btn>
            </div>
          </div>
          <div class="d-flex align-center justify-space-between my-3 " data-testid="infomanager-new__toolbar">
            <!-- /* TODO: Temporarily set to display: none; for current requirements. Will be updated in future versions. */ -->
              <div class="d-none" data-testid="infomanager-new__search-hidden"> 
            <lb-string placeholder="Search" label="" v-model="search" width="30vh" appendiconinner="mdi-magnify" hidedetails
              :isClearable="false" radius="8px" data-testid="infomanager-new__search-input" />
              <v-tooltip bottom content-class="tooltip-bottom">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ma-2" text icon color="lighten-2" v-bind="attrs" v-on="on" data-testid="infomanager-new__search-info-btn">
                    <v-icon data-testid="infomanager-new__search-info-icon">mdi-information</v-icon>
                    </v-btn>
                </template>
                <span>Search for the request information </span>
                </v-tooltip>
              </div>
            <v-spacer></v-spacer>

            <v-menu v-if="selectItem.length>0" class="radius-small" :close-on-content-click="false" offset-y transition="slide-y-transition" data-testid="infomanager-new__bulk-menu">
              <template v-slot:activator="{ on, attrs }">
                <v-tooltip left content-class="tooltip-left">
                  <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                  <v-btn icon v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }"  class="ml-2" data-testid="infomanager-new__bulk-btn"><v-icon data-testid="infomanager-new__bulk-icon">mdi-dots-horizontal</v-icon></v-btn>
                  </template>
                  <span>Bulk actions</span>
                </v-tooltip>
              </template>
              <v-list  class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width" data-testid="infomanager-new__bulk-list">
              <v-list-title class="ma-0  all-width" data-testid="infomanager-new__bulk-list-title">
                <div class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1 justify-space-between">
                  <p class="ma-0 font-weight-bold" data-testid="infomanager-new__bulk-list-title-label">Bulk Actions</p>
                  <v-icon color="primary" data-testid="infomanager-new__bulk-list-title-icon">mdi-information-outline</v-icon>
                </div>
                <v-divider></v-divider>
              </v-list-title>
              <v-list-item  class="d-flex px-2 all-width align-center  pa-0 ma-0 gray--text" @click="editRequestUser=true;getrequstedfromusers()" data-testid="infomanager-new__bulk-edit-requested-btn">
                <v-icon data-testid="infomanager-new__bulk-edit-requested-icon">mdi-pencil-outline</v-icon>
                <span class="noTransform" data-testid="infomanager-new__bulk-edit-requested-label">Edit 'Requested from'</span>
              </v-list-item>
            </v-list>
            </v-menu>
  
            <!-- Clear Filter Button -->
            <v-btn
              v-if="hasActiveTableFilter"
              text
              class="mr-2 data-table-action__clear-filter-btn"
              @click="clearTableFilter()"
              data-testid="infomanager-new__toolbar-clear-filter-btn"
            >
              <span>Clear Filter</span>
            </v-btn>
            <!-- Customize Column Menu Component -->
            <CustomizeColumnMenu
              v-model="customizeMenuOpen"
              :headers="headers"
              :show-save-button="false"
              data-testid-prefix="infomanager-new"
              @apply="handleApplyColumns"
            />
          </div>
          <div class="flex-fill-table">
          <lb-datatableaction
            ref="dataTableAction"
            :headers="headers"
            :tabledata="formateDataCopy"
            :filter-options-data="columnFilterSourceData"
            :itemsperpage="itemsPerPage"
            :displayedRowCount="paginatedFilteredItems.length"
            :searchterm="search"
            @select-all-change="select"
            :isDataSelected="selectItem.length > 0 && selectItem.length < paginatedFilteredItems.length ? true: false"
            @filter-item="filterPart"
            @filter-active-change="onFilterActiveChange"
            @clear-item="clearPart"
            data-testid="infomanager-new__datatable"
          >
            <template v-slot:tbody>
              <tr v-for="item in paginatedFilteredItems" :key="item._id"
                :class="{ 'low-opacity': item.status === false }"
                data-testid="infomanager-new__datatable-row">
                <td class="px-4" data-testid="infomanager-new__datatable-row-checkbox">
                  <v-checkbox dense color="caccounting" class="ma-0 py-1 single-line" :ripple="false" hide-details
                    :value="item['_id']" v-model="selectItem" @click="removeAllSelect()" data-testid="infomanager-new__datatable-checkbox"></v-checkbox>
                </td>
                <template v-for="(header,index) in headers">
                  <td v-if="header.visible && header.value !== 'action'" :key="index" class="px-4 single-line" :class="{'description-header': header.value === 'description'}"
                    data-testid="infomanager-new__datatable-cell">
                    <div v-if="header.value === 'tasklist'">
                      <OverflowList
                        v-if="(item.tasklist || []).length > 0 && item.tasklist[0].checklist_id"
                        :items="getLinkedTaskRefLabels(item.tasklist)"
                        position="bottom"
                        fixed
                        content-class="tooltip-bottom information-manager-fixed-tooltip"
                        data-testid="infomanager-new__datatable-tasklist-more"
                      >
                        <template #primary="{ item: refLabel }">
                          <span
                            class="pa-2 caccounting-background radius-mini caccounting--text"
                            data-testid="infomanager-new__datatable-tasklist-ref"
                          >{{ refLabel }}</span>
                        </template>
                      </OverflowList>
                    </div>
                    <div class="d-flex" v-else-if="header.value === 'location'">
                      <OverflowList
                        :items="getUniqueLocationNames(item.tasklist)"
                        position="bottom"
                        fixed
                        content-class="tooltip-bottom information-manager-fixed-tooltip"
                        data-testid="infomanager-new__datatable-location-more"
                      />
                    </div>
                    <div class="d-flex" v-else-if="header.value === 'task_category'">
                      <div class="d-flex">
                        <p class="ma-0 mr-2" data-testid="infomanager-new__datatable-task-category">{{(getTaskName(item.tasklist?.[0]?.checklist_id)).category }}</p>
                      </div>
                    </div>
                    <span v-else data-testid="infomanager-new__datatable-generic">{{ getItemData(item, header.value) }}</span>
                  </td>
                </template>
                <td class="px-3 single-line border-right border-left action-data" data-testid="infomanager-new__datatable-actions">
                  <v-tooltip left content-class="tooltip-left">
                    <template v-slot:activator="{ on }">
                      <v-btn icon @click="addEditForm(item)" v-on="on" :disabled="!item.status" data-testid="infomanager-new__datatable-edit-btn"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                    </template>
                    Edit
                  </v-tooltip>
                  <v-tooltip bottom content-class="tooltip-bottom" v-if="item.status">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon @click="enableDisableAccess(item._id, 'disable')" data-testid="infomanager-new__datatable-disable-btn"><v-icon color="success">mdi-check-circle</v-icon></v-btn>
                    </template>
                    <span>Disable</span>
                  </v-tooltip>
                  <v-tooltip bottom content-class="tooltip-bottom" v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon @click="enableDisableAccess(item._id, 'enable')" data-testid="infomanager-new__datatable-enable-btn"><v-icon color="error">mdi-close-circle</v-icon></v-btn>
                    </template>
                    <span>Enable</span>
                  </v-tooltip>
                  <activity-log
                      :resource-id="item._id" 
                      data-testid="infomanager-new__datatable-activity-log-btn"
                      :row-description="item.description"
                  />

                </td>
              </tr>
            </template>
          </lb-datatableaction>
          </div>

        </v-card-text>
      </v-card>
    
      <lb-drawer
        v-model="addeditdialog"
        :heading="addeditdata._id ? 'Update' : 'Create New Request'"
        width="600"
        :loading="addeditloading"
        data-testid="infomanager-new__drawer"
      >
        <template v-slot:body>
          <div>
            <v-row>
                    
              <v-col cols="12" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Requested Information*</p>
                <lb-textBox v-model="addeditdata.description" label="" requriedrows="3"
                  :error="addeditdataerror.description" data-testid="infomanager-new__textbox"/>
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Email*</p>
                <FreeformSelect
                  v-model="addeditdata.info_owner_email"
                  :items="infoOwnerEmails"
                  :error="addeditdataerror.info_owner_email"
                  placeholder=""
                  data-testid="infomanager-new__email-string"
                  @input="onInfoOwnerEmailChange"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Requested From*</p>
                <lb-string
                  v-model="addeditdata.info_owner_name"
                  label=""
                  :error="addeditdataerror.info_owner_name"
                  :disabled="isExistingInfoOwnerSelected"
                  :isClearable="!isExistingInfoOwnerSelected"
                  data-testid="infomanager-new__name-string"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Type*</p>
                <lb-dropdown
                    v-model="addeditdata.type"
                    label=""
                    :items="informationtypes"
                    :error="addeditdataerror.type"
                    data-testid="infomanager-new__type-dropdown"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Priority</p>
                <lb-dropdown
                    v-model="addeditdata.priority"
                    label=""
                    :items="requestpriority"
                    :error="addeditdataerror.priority"
                    data-testid="infomanager-new__priority-dropdown"
                />
              </v-col>
              <v-col v-if="normalizedEditType === 'link'" cols="12" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">File Upload Link*</p>
                <lb-string
                  v-model="addeditdata.uploadlink"
                  label=""
                  :error="addeditdataerror.uploadlink"
                  data-testid="infomanager-new__uploadlink-string"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Classification*</p>
                <lb-string 
                    v-model="addeditdata.category"
                    label=""
                    :error="addeditdataerror.category"
                    data-testid="infomanager-new__classification-string"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Due Days</p>
                <lb-number
                  v-model="addeditdata.duedate"
                  placeholder="Enter value between -200 and 200"
                  label=""
                  min="-200"
                  :max="200"
                  :error="addeditdataerror.duedate"
                  data-testid="infomanager-new__duedate-number"
                />
              </v-col>
              <v-col cols="12">
                    <span class="font-size-lg font-weight-semibold"> Select Tasks:</span>
                    <br />
                      <div class="align-center justify-start">
                      <template
                        v-for="(item, index) in selectedTask"
                      >
                      <v-chip
                        label
                        class="caccounting--text lightpurple ma-1"
                        :key="index"
                        close
                        @click:close="toggleTaskSelection(item)"
                        data-testid="infomanager-new__selected-task-chip"
                      >
                          <span>{{ getTaskName(item.checklist_id).ref  }}</span>
                        </v-chip>
                      </template>
                      </div>
                </v-col>

                <v-col cols="12" class="my-0 py-1">
                    <v-menu
                      :close-on-content-click="false"
                      offset-y
                      transition="slide-y-transition"
                      ref="accountMenu"
                      data-testid="infomanager-new__task-menu"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-bind="attrs"
                          v-on="on"
                          class="all-width align-center border-on justify-space-between"
                          data-testid="infomanager-new__task-btn"
                          ><span>Select Task</span
                          ><v-icon>mdi-chevron-down</v-icon></v-btn
                        >
                      </template>
                      
                      <v-list
                        class="ma-0 d-flex flex-column align-start justify-start all-width pa-2"
                      >
                        <div class="custom-task-list">
                          <lb-string
                            label="Search"
                            class="all-width"
                            hidedetails
                            v-model="searchTasks"
                            @input="searchTasks = $event"
                            data-testid="infomanager-new__task-search"
                          />
                          <v-simple-table dense class="all-width mt-2 border-on radius-small">
                            <thead class="tableHeaderBg">
                              <tr>
                                <th class="gray-background">
                                  <v-checkbox
                                    v-if="multiSelectMode"
                                    class="ma-0 pa-0"
                                    hide-details
                                    color="caccounting"
                                    :input-value="selectAllTask"
                                    @change="selectAllTask = !selectAllTask; toggleSelectAllTasks()"
                                    data-testid="infomanager-new__select-all-checkbox"
                                  ></v-checkbox>
                                </th>
                                <th class="gray-background" scope="ref">Ref</th>
                                <th class="gray-background" scope="location">
                                  {{ $store.state.LocationHeader || "Location" }}
                                </th>
                                <th class="gray-background" scope="ref">Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-for="(v, k) in filteredTaskList">
                                <tr :key="k">
                                  <td>
                                    <v-checkbox
                                      class="mt-0"
                                      dense
                                      label=""
                                      hide-details
                                      :input-value="isTaskSelected(v)"
                                      @change="toggleTaskSelection(v)"
                                      data-testid="infomanager-new__task-checkbox"
                                    ></v-checkbox>
                                  </td>
                                  <td>{{ v.ref }}</td>
                                  <td>{{ v.location_name }}</td>
                                  <td>{{ v.description }}</td>
                                </tr>
                              </template>
                            </tbody>
                          </v-simple-table>
                        </div>
                        <!-- Selected Accounts Table -->
                      
                        <div class="d-flex align-center all-width justify-end mt-2">
                          <v-btn
                            data-testid="infomanager-new__select-button"
                            class="ml-2 white--text"
                            color="primary"
                            @click="$refs.accountMenu.isActive = false; selectTasks();"
                            ><span>Select</span></v-btn
                          >
                        </div>
                      </v-list>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" class="my-0 py-1">
              <div v-if="selectedTask.length > 0" class="mt-4">
                <div>
                  <v-simple-table class="all-width mt-2 border-on radius-small selected-accounts-scroll">
                    <thead class="tableHeaderBg">
                      <tr>
                        <th class="tableHeaderBg pa-2" data-testid="infomanager-new__reference-header">Reference</th>
                        <th class="tableHeaderBg pa-2" data-testid="infomanager-new__location-header">Location</th>
                        <th class="tableHeaderBg pa-2" data-testid="infomanager-new__description-header">Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in selectedTask" :key="index">
                        <td data-testid="infomanager-new__reference-cell">{{ getTaskName(item.checklist_id).ref }}</td>
                        <td data-testid="infomanager-new__location-cell">{{ getLocationName(item.location) }}</td>
                        <td data-testid="infomanager-new__description-cell">{{ getTaskName(item.checklist_id).description }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </div>
                        </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:actions>
          <span class="caption">*Required</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addEditItem()" data-testid="infomanager-new__drawer-save-btn">
            <span v-if="addeditdata._id" data-testid="infomanager-new__drawer-update-btn">Update</span>
            <span v-else data-testid="infomanager-new__drawer-create-btn">Create Request</span>
          </v-btn>
        </template>
      </lb-drawer>

      <lb-drawer
        v-model="editRequestUser"
        heading="Edit 'Request From'"
        width="600"
        :loading="loading"
        data-testid="infomanager-new__edit-request-drawer"
      >
        <template v-slot:body>
          <div class="" data-testid="infomanager-new__edit-request-body">
            <v-row>
              <v-col cols="6" data-testid="infomanager-new__edit-request-chip-col">
                <v-chip color="lightpurple" class="caccounting--text" data-testid="infomanager-new__edit-request-chip">
                  <v-icon class="mr-1" data-testid="infomanager-new__edit-request-chip-icon">mdi-information-outline</v-icon>
                  <span data-testid="infomanager-new__edit-request-chip-label">{{ selectItem.length }} information requests selected</span>
                </v-chip>
              </v-col>
              <v-col cols="12" data-testid="infomanager-new__edit-request-actions-col">
                <p class="pa-0 ma-0 text-font-size-md mb-1" data-testid="infomanager-new__edit-request-actions-label">Actions*</p>
                <lb-dropdown
                  v-model="edituserlist.action"
                  label=""
                  :items="editRequestActions"
                  :error="edituserlisterror.action"
                  data-testid="infomanager-new__edit-request-actions-dropdown"
                />
              </v-col>
              <v-col cols="12" data-testid="infomanager-new__edit-request-existing-col">
                <p class="pa-0 ma-0 text-font-size-md mb-1" data-testid="infomanager-new__edit-request-existing-label">Existing</p>
                <lb-string
                  label=""
                  v-model="edituserlist.existing_owner_emails"
                  :disabled="true"
                  :isClearable="false"
                  hidedetails
                  data-testid="infomanager-new__edit-request-existing-string"
                />
              </v-col>
              <v-col cols="6" data-testid="infomanager-new__edit-request-email-col">
                <p class="pa-0 ma-0 text-font-size-md mb-1" data-testid="infomanager-new__edit-request-email-label">Email*</p>
                <FreeformSelect
                  v-model="edituserlist.new_info_owner_email"
                  :items="infoOwnerEmails"
                  :error="edituserlisterror.new_info_owner_email"
                  placeholder=""
                  data-testid="infomanager-new__edit-request-email-select"
                  @input="onReplaceInfoOwnerEmailChange"
                />
              </v-col>
              <v-col cols="6" data-testid="infomanager-new__edit-request-replace-col">
                <p class="pa-0 ma-0 text-font-size-md mb-1" data-testid="infomanager-new__edit-request-replace-label">Requested From*</p>
                <lb-string
                  v-model="edituserlist.new_info_owner_name"
                  label=""
                  :error="edituserlisterror.new_info_owner_name"
                  :disabled="isExistingReplaceInfoOwnerSelected"
                  :isClearable="!isExistingReplaceInfoOwnerSelected"
                  data-testid="infomanager-new__edit-request-replace-string"
                />
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:actions>
          <span class="caption" data-testid="infomanager-new__edit-request-actions-required">*Required</span>
          <v-spacer></v-spacer>
          <v-btn class="py-4" color="primary" @click="updaterequesteduser()" data-testid="infomanager-new__edit-request-actions-replace-btn">
            <span data-testid="infomanager-new__edit-request-actions-replace-label">Replace</span>
          </v-btn>
        </template>
      </lb-drawer>

      <!-- Pagination -->
      <Pagination :list="filteredItemsfromsearch" :itemsperpage="itemsPerPage" @paginated-data="setPaginatedData" data-testid="financialstatement-preparation__pagination" />

   </div>
</template>
  
  <script>
  import bulkPBCUpload from "./components/BulkUploadInformationManager/BulkUploadInformationManager.vue";
  import Pagination from "../../../components/Pagination/Pagination.vue";
  import CustomizeColumnMenu from "../../../components/CustomizeColumnMenu/CustomizeColumnMenu.vue";
  import ActivityLog from "../../../components/ActivityLog/ActivityLog.vue";
  import { FreeformSelect } from "../../../components";
  import { OverflowList } from "@/modules/financialclose/components";
  import { ACTIVITY_LOG_TYPES, ERROR_MESSAGES, INFORMATION_MANAGER_TYPE_OPTIONS } from "../../../utils/constants";
  import { formatRequestTypeLabel, normalizeTypeAlias, validateDueDays, validateEmail, validateUploadLink, flattenApiFieldErrors, firstErrorMessage } from "../../../utils/bulkUploadValidation";
  import {
    TASK_LINKED_FILTER_FIELD,
    LOCATION_FILTER_FIELD,
    TASK_CATEGORY_FILTER_FIELD,
    getLinkedTaskEntries,
    buildTaskLinkedFilterValues,
    buildLocationFilterValues,
    buildTaskCategoryFilterValues,
    normalizeInfoManagerFilterCriteria,
  } from "./InformationManagerUtils";
  export default {
    name: "financialclose_master_informationmanager",
     ACTIVITY_LOG_TYPES,
    // props: ['props'],
    data: function () {
      return {
        right: "financialclose_master_informationmanager",
        clientID:this.$store.state.client,
        addeditdata: {},
        addeditdataerror: {},
        informationtypes: INFORMATION_MANAGER_TYPE_OPTIONS.map((opt) => ({
          value: opt.value,
          name: opt.name,
        })),
        requestpriority:[
            "High",
            "Medium",
            "Low"
        ],
        addeditdialog: false,
        checklist: [],
        infoOwners: [],
        addeditloading: false,
        addedittaskloading: false,
        addedittaskdialog:false,
        loading: false,
        hasActiveTableFilter: false,
        listdata: [],
        headers: [
          {
            value: "indexno",
            text: "S No",
            visible: true,
            filterable:false,
            sortable: false,

          },
          {

            value: "description",
            text: "Request Information",
            visible: true,
            filterable:true,
            sortable: true,

          },
          {
            value: "type",
            text: "Type",
            visible: true,
            filterable:true,
            sortable: true,
          },
  
          {
            value: "category",
            text: "Classification",
             visible: true,
            filterable:true,
            sortable: true,
          },
          {
            value: "info_owner_name",
            text: "Requested From",
             visible: true,
            filterable:true,
            sortable: true,
          },
          {
            value: "info_owner_email",
            text: "Email ID",
             visible: true,
            filterable:true,
            sortable: true,
          },
          {
            value: "tasklist",
            text: "Task Linked",
             visible: true,
            filterable:true,
            sortable: false,
          },
          {
            value:"task_category",
            text:"Task Category",
             visible: true,
            filterable:true,
            sortable: false,
          },
          {
            value: "duedate",
            text: "Due Days",
            visible: true,
            filterable:true,
            sortable: false,
          },
          {
            value: "location",
            text: this.$store.state.LocationHeader || 'Location',
             visible: true,
            filterable:true,
            sortable: false,
          },
          {
            value: "created_at",
            text: "Created On",
             visible: true,
            filterable:true,
            sortable: true,
          },
          {
            value: "updated_at",
            text: "Updated On",
             visible: true,
             filterable:true,
            sortable: true,
          },
          {
            value:"priority",
            text:"Priority",
             visible: true,
            filterable:true,
            sortable: false,
          },
          {
            value: "action",
            text: "Action",
            sticky:true,
            visible: true,
            filterable:false,
            sortable: false,
          },
        ],
        selectedTaskHeaders:[
          {  title: 'Reference', align: 'start', key: 'ref',},
          { title: 'Descriptions', align: 'end', key: 'checklist' },
          { title: 'Location', align: 'end', key: 'location' },
          { title: 'Actions', value: 'actions', sortable: false },

        ],
        formatedData: [],
        formateDataCopy:[],
        selectchecklist_id:'',
        selectlocation_id:'',
        tasklistlocation:[],
        addedittaskdataerror:{},
        location_details:[],
        tasklocation_details:[],
        locationfilter:[],
        selectedFilterItems: [],
        searchTask:'',
        selecttaskstep:0,
        searchcolumn:'',
        customizeMenuOpen: false,
        search:"",
        itemsPerPage:13,
        selectAll:false,
        selectItem:[],
        editRequestUser:false,
        editRequestActions:["Replace"],
        paginatedFilteredItems:[],
        edituserlist:{},
        edituserlisterror: {},
        usersList:[],
        selectedUser:null,
        selectedTask: [], // Array of selected account objects or IDs
        selectAllTask: false, // For multi-select "select all"
        multiSelectMode: true,
        searchTasks:'',
        activeFilter: null,
      };
    },
    created() {
      this.init();
    },
    activated() {
      this.init();
    },
    components: {
      bulkPBCUpload,
      Pagination,
      CustomizeColumnMenu,
     ActivityLog,
     FreeformSelect,
     OverflowList,
    },
    computed:{
       filteredTaskList() {
        const term = (this.searchTasks || '').toLowerCase();
        if (!term) return this.filterTasklistList;
        return this.filterTasklistList.filter(v =>
          (v.description && v.description.toLowerCase().includes(term)) ||
          (v.ref && String(v.ref).toLowerCase().includes(term)) ||
          (v.location_name && v.location_name.toLowerCase().includes(term))
        );
      },
       filterTasklistList() {
        // Returns a flattened array of checklist items, each with a single location
        if (!Array.isArray(this.checklist)) return [];
        return this.checklist.flatMap(item => {
          if (item.location && item.location.length > 0) {
            return item.location.map(loc => {
              const newItem = { ...item };
              newItem.ref = `${item.ref}`;
              newItem.location_name = loc.name;
              newItem.location = loc._id;
              newItem.checklist_id = item._id;
              return newItem;
            });
          } else {
            return [];
          }
        });
      },
        filtertasklist(){            
            return this.checklist.filter(item =>
                item.description.toLowerCase().includes(this.searchTask.toLowerCase())
            );
        },

        filteredHeaders() {
          const searchTerm = this.searchcolumn.toLowerCase();
          return this.headers.filter(header =>
            header.text.toLowerCase()?.includes(searchTerm)
          );
        },
        normalizedEditType() {
          return normalizeTypeAlias(this.addeditdata?.type) || this.addeditdata?.type || '';
        },
        infoOwnerEmails() {
          return (this.infoOwners || [])
            .map((owner) => (owner.email || '').toString().trim())
            .filter(Boolean);
        },
        isExistingInfoOwnerSelected() {
          if (this.addeditdata?.info_owner) return true;
          return !!this.findInfoOwnerByEmail(this.addeditdata?.info_owner_email);
        },
        isExistingReplaceInfoOwnerSelected() {
          if (this.edituserlist?.info_owner) return true;
          return !!this.findInfoOwnerByEmail(this.edituserlist?.new_info_owner_email);
        },
        /**
         * ColumnFilter flattens primitive arrays into distinct checkbox options.
         * Display rows keep tasklist as link objects, so this source exposes
         * unique primitive values on the header.value keys for the option list.
         */
        columnFilterSourceData() {
          return (this.formateDataCopy || []).map((row) => ({
            ...row,
            tasklist: Array.isArray(row[TASK_LINKED_FILTER_FIELD])
              ? row[TASK_LINKED_FILTER_FIELD]
              : row.tasklist,
            location: Array.isArray(row[LOCATION_FILTER_FIELD])
              ? row[LOCATION_FILTER_FIELD]
              : row.location,
            task_category: Array.isArray(row[TASK_CATEGORY_FILTER_FIELD])
              ? row[TASK_CATEGORY_FILTER_FIELD]
              : row.task_category,
          }));
        },
        filteredItemsfromsearch() {          
          let filteredData = this.formatedData.filter(item =>
            item.description.toLowerCase().includes(this.search.toLowerCase())
          );

          if (this.selectedFilterItems.length > 0) {
            filteredData = filteredData.filter(item => {
              return this.selectedFilterItems.every(filter => {
                return Object.entries(filter).every(([key, values]) => {
                  const itemValue = item[key];
                  return Array.isArray(itemValue)
                    ? itemValue.some(val => values.includes(val))
                    : values.includes(itemValue);
                });
              });
            });
          }

          return filteredData;
        },

    },
    methods: {
      /**
       * Handler for filter-active-change event from DataTableAction
       */
      onFilterActiveChange(isActive) {
        this.hasActiveTableFilter = isActive;
      },
      /**
       * Clear table filters via DataTableAction ref
       */
      clearTableFilter() {
        if (this.$refs.dataTableAction) {
          this.$refs.dataTableAction.clearFilter();
        }
      },
      formateData() {
        let ObjectTemp = {};
        let ArrayTemp = [];
        this.listdata.forEach((item, index) => {
          const taskLinks = getLinkedTaskEntries(item);
          ObjectTemp = {
            __key: index,
            __formatedkey: index,
            _id: item._id,
            indexno: index + 1,
            type: normalizeTypeAlias(item.type) || item.type,
            category: item.category?.trim(),
            description: item.description?.trim(),
            duedate:item.duedate,
            info_owner: item.info_owner || null,
            info_owner_email: item.info_owner_email?.trim(),
            info_owner_name: item.info_owner_name?.trim(),
            priority: item.priority,
            uploadlink: item.uploadlink || '',
            urgent: item.urgent,
            tasklist: item.checklist_id,
            [TASK_LINKED_FILTER_FIELD]: buildTaskLinkedFilterValues(taskLinks, (id) => this.getTaskName(id)),
            location: this.getLocationName(item.tasklist?.[0]?.location),
            [LOCATION_FILTER_FIELD]: buildLocationFilterValues(taskLinks, (id) => this.getLocationName(id)),
            [TASK_CATEGORY_FILTER_FIELD]: buildTaskCategoryFilterValues(taskLinks, (id) => this.getTaskName(id)),
            checklist_id_detail: item.checklist_id_detail,
            created_at: item.created_at?.split("T")[0],
            updated_at: item.updated_at?.split("T")[0],
            status: item.status,
          };
          ArrayTemp.push(ObjectTemp);
        });
        this.formatedData = ArrayTemp;
        this.formateDataCopy = ArrayTemp;
      },
      init() {
        this.refreshData();
      },
      setPaginatedData(paginationInfo) {
        if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
            this.paginatedFilteredItems = paginationInfo.data || [];
            this.page = paginationInfo.page || 1;
        } else {
            this.paginatedFilteredItems = paginationInfo || [];
        }
      },
      refreshData() {
        this.charts = [];
        this.chartdata = {};
        this.listdata = [];
        this.locationfilter = [];
        this.getData();
      },
      getData() {
        this.loading = true;
        return this.axios
          .post("/v2/financialclose/masters/informationmanager/formData")
          .then((dt) => {
            if (dt.data.status === "success") {
              let formdt = dt.data.data[0] || {};
              this.checklist = formdt.checklist || [];
              this.infoOwners = formdt.info_owners || [];
              return this.axios.post(
                "/v2/financialclose/masters/informationmanager/get"
              );
            } else throw new Error("Error reading form data");
          })
          .then((dt) => {
            this.listdata = [];
            if (dt.data.status === "success") {
              this.listdata = dt.data.data;
              this.formateData();
            } else throw new Error(dt.data.message);
          }).then(() => {
             this.axios
                .post("/v2/financialclose/location/get")
                .then((ele) => {
                  this.location_details = ele.data.data;
                })
                .catch((err) => {
                  console.log(err);
                });
          }).then(() => {
          return this.axios.post(
            "/v2/financialclose/masters/checklist/getformdata"
          );
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            let formdata = dt.data.data[0] || {};
            this.usersList = formdata.users;
           
          } else throw new Error(dt.data.message);
        })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
          })
          .finally(() => {
            this.loading = false;
          });
      },

      /**
       * Handle Apply button click from CustomizeColumnMenu
       * Updates column visibility locally (session only)
       * @param {Array} headers - Updated headers array
       */
      handleApplyColumns(headers) {
        this.headers = headers;
        this.customizeMenuOpen = false;
      },

      addTableHeader(item) {
        this.headers.find((x) => x === item ? x.visible = !x.visible : "")
      },
      select() {
        this.selectItem = [];
        this.selectAll=!this.selectAll

        if (this.selectAll) {
          for (let i in this.paginatedFilteredItems) {
            this.selectItem.push(this.paginatedFilteredItems[i]['_id']);
          }
        } else {
          this.selectItem = [];
        }
      },
      removeAllSelect() {
        if (this.selectItem.length === this.formatedData.length) this.selectAll = true;
        else this.selectAll = false;
      },
      addForm(){
        this.addeditdata = {};
        this.addeditdataerror = {};
        this.tasklocation_details=[],
        this.addeditdialog = true;
        this.tasklistlocation = [];
      },
      findInfoOwnerByEmail(email) {
        const key = (email == null ? '' : String(email)).trim().toLowerCase();
        if (!key) return null;
        return (this.infoOwners || []).find((owner) =>
          (owner.email || '').toString().trim().toLowerCase() === key
        ) || null;
      },
      onInfoOwnerEmailChange(email) {
        const next = email == null ? '' : String(email);
        this.$set(this.addeditdata, 'info_owner_email', next);
        const match = this.findInfoOwnerByEmail(next);
        if (match) {
          this.$set(this.addeditdata, 'info_owner_name', match.name || '');
          this.$set(this.addeditdata, 'info_owner', match._id);
        } else {
          if (this.addeditdata.info_owner) {
            this.$set(this.addeditdata, 'info_owner_name', '');
          }
          this.$set(this.addeditdata, 'info_owner', null);
        }
      },
      addRequirement(){
         this.addeditdialog = true; 
         this.addeditdata = { type: 'fileupload', priority: 'Medium', uploadlink: '', info_owner: null, info_owner_email: '', info_owner_name: '' };  
         this.addeditdataerror = {}; 
         this.locationUserList = []; 
         this.customassertions = false; 
         this.tasklistlocation = []; 
         this.selectedTask = [];
      },
      addEditForm(dt = {}) {
      const normalizedType = normalizeTypeAlias(dt.type) || dt.type || 'fileupload';
      const row = { ...dt };
      delete row[TASK_LINKED_FILTER_FIELD];
      delete row[LOCATION_FILTER_FIELD];
      delete row[TASK_CATEGORY_FILTER_FIELD];
      this.addeditdata = {
        ...row,
        type: normalizedType,
        uploadlink: normalizedType === 'link' ? (dt.uploadlink || '') : '',
      };
      const matchedOwner = this.findInfoOwnerByEmail(this.addeditdata.info_owner_email)
        || (this.infoOwners || []).find((owner) =>
          this.addeditdata.info_owner && String(owner._id) === String(this.addeditdata.info_owner)
        );
      if (matchedOwner) {
        this.addeditdata.info_owner = matchedOwner._id;
        this.addeditdata.info_owner_name = matchedOwner.name || this.addeditdata.info_owner_name;
      }
      this.selectedTask = [];
      // Sync both tasklistlocation and selectedTask with the current tasklist (if present)
      this.tasklistlocation = Array.isArray(this.addeditdata.tasklist) ? JSON.parse(JSON.stringify(this.addeditdata.tasklist)) : [];
      this.selectedTask = Array.isArray(this.addeditdata.tasklist) ? JSON.parse(JSON.stringify(this.addeditdata.tasklist)) : [];
      this.addeditdataerror = {};
      this.addeditdialog = true;
          },
      getItemData(item, key) {
        if (key === 'type') {
          return formatRequestTypeLabel(item.type) || item.type || '';
        }
        return item[key];
      },
       validateAddEditData(data) {
        let errors = {};
        let hasError = false;
        const requiredFields = [
          { key: 'description', label: 'Requested Information' },
          { key: 'info_owner_name', label: 'Requested From' },
          { key: 'type', label: 'Type' },
          { key: 'category', label: 'Classification' },
        ];
        requiredFields.forEach(field => {
          const value = data[field.key];
          if (
            value === undefined ||
            value === null ||
            (typeof value === 'string' && value.trim() === '') ||
            (Array.isArray(value) && value.length === 0)
          ) {
            errors[field.key] = `${field.label} is required`;
            hasError = true;
          }
        });
        const emailResult = validateEmail(data.info_owner_email, { required: true });
        if (emailResult.error) {
          errors.info_owner_email = emailResult.error;
          hasError = true;
        }
        const dueDaysResult = validateDueDays(data.duedate, { required: false });
        if (dueDaysResult.error) {
          errors.duedate = dueDaysResult.error;
          hasError = true;
        }
        const requestType = normalizeTypeAlias(data.type) || data.type;
        if (requestType === 'link') {
          const linkResult = validateUploadLink(data.uploadlink, { required: true });
          if (linkResult.error) {
            errors.uploadlink = linkResult.error;
            hasError = true;
          }
        } else if (data.uploadlink && String(data.uploadlink).trim()) {
          errors.uploadlink = ERROR_MESSAGES.UPLOAD_LINK_NOT_ALLOWED;
          hasError = true;
        }
        return { errors, hasError };
      },
      addEditItem() {
  // Validation
  this.addeditdataerror = {};
  const { errors } = this.validateAddEditData(this.addeditdata);
  this.addeditdataerror = errors;
  if (Object.keys(errors).length > 0) {
        this.$store.commit("sbError", firstErrorMessage(errors) || "Please fill all required fields correctly.");
        return;
    }
  this.addeditloading = true;
        let type = "add";
        let url = "/v2/financialclose/masters/informationmanager/add";
        if (this.addeditdata._id) {
          type = "edit";
          url =
            "/v2/financialclose/masters/informationmanager/edit/" +
            this.addeditdata._id;
        }
        this.addeditdata.checklist_id = this.selectedTask;
        let ndt = { ...this.addeditdata };
        delete ndt._id;
        const normalizedType = normalizeTypeAlias(ndt.type) || ndt.type;
        ndt.type = normalizedType;
        ndt.uploadlink = normalizedType === 'link'
          ? validateUploadLink(ndt.uploadlink, { required: true }).value
          : '';
        ndt.info_owner_email = (ndt.info_owner_email || '').toString().trim();
        ndt.info_owner_name = (ndt.info_owner_name || '').toString().trim();
        ndt.info_owner = ndt.info_owner || null;
        this.axios
          .post(url, { data: ndt })
          .then((dt) => {
            if (dt.data.status === "success") {
              if (type === "add")
                this.$store.commit("sbSuccess", "New Request added");
              else this.$store.commit("sbSuccess", "Request updated");
              this.addeditdialog = false;
              this.refreshData();
            } else {
              const apiErrors = dt.data?.data?.[0]?.index0;
              if (apiErrors) {
                this.addeditdataerror = flattenApiFieldErrors(apiErrors);
              }
              const toast =
                firstErrorMessage(this.addeditdataerror) ||
                dt.data.message ||
                (type === 'add' ? ERROR_MESSAGES.ERROR_ADDING_REQUEST : ERROR_MESSAGES.ERROR_EDITING_REQUEST);
              this.$store.commit('sbError', toast);
            }
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || ERROR_MESSAGES.UNKNOWN_ERROR);
            console.log('[InformationManager]:', err);
          })
          .finally(() => {
            this.addeditloading = false;
          });
      },
      enableDisableAccess(id, action) {
        this.loading = true;
        let url = "/v2/financialclose/masters/informationmanager/disable/";
        if (action === "enable") {
          url = "/v2/financialclose/masters/informationmanager/enable/";
        }
        this.axios
          .post(url + id, {})
          .then((dt) => {
            if (dt.data.status === "success") {
              if (action === "enable") {
                this.$store.commit("sbSuccess", "Item enabled");
                // this.listdata[k].status = true;
              } else {
                this.$store.commit("sbSuccess", "Item disabled");
                // this.listdata[k].status = false;
              }
              this.refreshData();
            } else throw new Error(dt.data.message || "Error performing action");
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      selectTaskLocation(id){
        this.selectlocation_id=[...this.selectlocation_id , id]        
      },
      addEditTaskItem() {
        if (this.selectchecklist_id && this.selectlocation_id) {
          this.selectlocation_id.forEach((item) => {
            let exists = this.tasklistlocation.some(
              (t) => t.checklist_id === this.selectchecklist_id && t.location === item
            );
            if (!exists) {
              let obj = {
                checklist_id: this.selectchecklist_id,
                location: item,
              };
              this.tasklistlocation.push(obj);
            }
          });
          this.addedittaskdialog = false;
        } else {
          this.$store.commit("sbError", "Tasklist and location required");
        }
        this.selectchecklist_id = "";
        this.selectlocation_id = "";
      },
      getLocationName(locationId) {
        const id = locationId != null ? String(locationId) : '';
        const location = (this.location_details || []).find(
          (loc) => String(loc._id) === id
        );
        return location ? location.name : '';
      },
      getTaskName(taskId) {
        const id = taskId != null ? String(taskId) : '';
        const task = (this.checklist || []).find((item) => String(item._id) === id);
        return task || {};
      },
      getLinkedTaskOverflowCount(tasklist) {
        const list = tasklist || [];
        return list.length > 1 ? list.length - 1 : 0;
      },
      getLinkedTaskOverflowItems(tasklist) {
        return (tasklist || []).slice(1);
      },
      getLinkedTaskRefLabels(tasklist) {
        const list = tasklist || [];
        const labelFor = (entry) => (this.getTaskName(entry && entry.checklist_id) || {}).ref || '—';
        if (!list.length) return [];
        return [labelFor(list[0])].concat(this.getLinkedTaskOverflowItems(list).map(labelFor));
      },
      getUniqueLocationNames(tasklist) {
        const names = [];
        const seen = new Set();
        (tasklist || []).forEach((entry) => {
          const name = this.getLocationName(entry?.location);
          if (name && !seen.has(name)) {
            seen.add(name);
            names.push(name);
          }
        });
        return names;
      },
      getLocationOverflowCount(tasklist) {
        const uniqueNames = this.getUniqueLocationNames(tasklist);
        return uniqueNames.length > 1 ? uniqueNames.length - 1 : 0;
      },
       removetasklist(item){
        let indexItem = this.tasklistlocation.indexOf(item);
        this.tasklistlocation.splice(indexItem, 1);
      },
      selectLocation(Id){
        let taskLoc = '';
        if (Id) {
           taskLoc = this.checklist.find((x) => x._id === Id);
        }        
        this.selectchecklist_id=Id
        this.tasklocation_details = taskLoc.location;        
      },
      locationFilterFun(locationid){
        this.loading = true;
        if (locationid) {
          this.axios
            .post("/v2/financialclose/masters/informationmanager/getinfomationwithfilter/"+locationid)
            .then((ele) => {
               if (ele.data.status === "success") {
                this.listdata = ele.data.data;
                this.formateData();
               }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
            this.loading = false;
          });
        }
      },
      getrequstedfromusers() {
        const selectedItemsData = this.formatedData.filter((item) => this.selectItem.includes(item._id));
        const emails = [...new Set(selectedItemsData
          .map((item) => (item.info_owner_email || '').toString().trim())
          .filter(Boolean))];
        this.edituserlist = {
          action: 'Replace',
          ids: [...this.selectItem],
          existing_owner_emails: emails.join(', '),
          exiting_info_owner_email: emails,
          new_info_owner_email: '',
          new_info_owner_name: '',
          info_owner: null,
        };
        this.edituserlisterror = {};
      },
      onReplaceInfoOwnerEmailChange(email) {
        const next = email == null ? '' : String(email);
        this.$set(this.edituserlist, 'new_info_owner_email', next);
        const match = this.findInfoOwnerByEmail(next);
        if (match) {
          this.$set(this.edituserlist, 'new_info_owner_name', match.name || '');
          this.$set(this.edituserlist, 'info_owner', match._id);
        } else {
          if (this.edituserlist.info_owner) {
            this.$set(this.edituserlist, 'new_info_owner_name', '');
          }
          this.$set(this.edituserlist, 'info_owner', null);
        }
      },
      validateReplaceUserData(data) {
        const errors = {};
        if (!data.action) {
          errors.action = 'Action is required';
        }
        if (!Array.isArray(data.ids) || !data.ids.length) {
          errors.ids = 'Select at least one information request';
        }
        const emailResult = validateEmail(data.new_info_owner_email, { required: true });
        if (emailResult.error) {
          errors.new_info_owner_email = emailResult.error;
        }
        const existingOwner = data.info_owner || this.findInfoOwnerByEmail(data.new_info_owner_email);
        if (!existingOwner) {
          const name = (data.new_info_owner_name || '').toString().trim();
          if (!name) {
            errors.new_info_owner_name = ERROR_MESSAGES.REQUESTED_FROM_REQUIRED;
          }
        }
        return { errors, hasError: Object.keys(errors).length > 0 };
      },
      updaterequesteduser() {
        this.edituserlisterror = {};
        const { errors } = this.validateReplaceUserData(this.edituserlist || {});
        this.edituserlisterror = errors;
        if (Object.keys(errors).length > 0) {
          this.$store.commit('sbError', firstErrorMessage(errors) || 'Please fill all required fields correctly.');
          return;
        }
        const payload = {
          ids: [...(this.edituserlist.ids || [])],
          new_info_owner_email: (this.edituserlist.new_info_owner_email || '').toString().trim(),
          new_info_owner_name: (this.edituserlist.new_info_owner_name || '').toString().trim(),
          info_owner: this.edituserlist.info_owner || null,
          exiting_info_owner_email: Array.isArray(this.edituserlist.exiting_info_owner_email)
            ? this.edituserlist.exiting_info_owner_email
            : [],
        };
        this.loading = true;
        this.axios
          .post("/v2/financialclose/masters/informationmanager/updateinfouser", { data: [payload] })
          .then((ele) => {
            if (ele.data.status === "success") {
              this.editRequestUser = false;
              this.selectItem = [];
              this.selectAll = false;
              this.$store.commit("sbSuccess", "Requested From updated");
              this.refreshData();
            } else {
              this.$store.commit("sbError", ele.data.message || "Error replacing requested from");
            }
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || ERROR_MESSAGES.UNKNOWN_ERROR);
            console.log('[InformationManager]:', err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    filterPart(item){
      // Save filter criteria for reapplication after data refresh
      const criteria = normalizeInfoManagerFilterCriteria(item);
      this.activeFilter = JSON.parse(JSON.stringify(criteria));
      this.formatedData = this.$nova.filterByDynamicCriteria(this.formateDataCopy, criteria);
    },
    clearPart(item){
      console.log(item,"item");
      this.activeFilter = null;
      this.formatedData = this.formateDataCopy;
    },
    selectTasks(){
      this.addeditdata.tasklist = this.selectedTask;
    },
    toggleTaskSelection(account) {
    const minimal = { checklist_id: account.checklist_id, location: account.location };
    if (this.multiSelectMode) {
      // Multi-select: add/remove from array
      const idx = this.selectedTask.findIndex(a => String(a.checklist_id) === String(account.checklist_id) && String(a.location) === String(account.location));
      if (idx > -1) {
        this.selectedTask.splice(idx, 1);
      } else {
        this.selectedTask.push(minimal);
      }
    } else {
      // Single-select: only one can be selected
      this.selectedTask = [minimal];
    }
  },
  isTaskSelected(account) {
    // Ensure both checklist_id and location are compared as strings for robust matching
    return this.selectedTask.some(a =>
      String(a.checklist_id) === String(account.checklist_id) &&
      String(a.location) === String(account.location)
    );
  },
  toggleSelectAllTasks() {
    if (this.selectAllTask) {
       this.selectedTask = this.filterTasklistList.map(item => ({
        checklist_id: item.checklist_id,
        location: item.location
      }));
    } else {
      this.selectedTask = [];
    }
  },
},
    watch: {
      // Reapply filter when data is refreshed
      formateDataCopy: {
        handler(newList) {
          if (this.activeFilter) {
            this.formatedData = this.$nova.filterByDynamicCriteria(newList, this.activeFilter);
          } else {
            this.formatedData = newList;
          }
        },
        deep: true
      },
      location_details() {
        if (this.listdata && this.listdata.length) {
          this.formateData();
        }
      },
      selectedTask() {
        // Keep selectAllTask in sync
        this.selectAllTask = this.filterTasklistList.length > 0 &&
          this.filterTasklistList.every(account => this.isTaskSelected(account));
      },
      // If the dialog is opened with a different tasklist, update selectedTask
      'addeditdata.tasklist': {
        handler(newVal) {
          this.selectedTask = Array.isArray(newVal) ? JSON.parse(JSON.stringify(newVal)) : [];
        },
        immediate: false
      },
      'addeditdata.type'(newType) {
        const normalized = normalizeTypeAlias(newType) || newType;
        if (normalized !== 'link' && this.addeditdata) {
          this.$set(this.addeditdata, 'uploadlink', '');
        }
      },
      editRequestUser(isOpen) {
        if (isOpen) {
          this.getrequstedfromusers();
        }
      },
    },
  };
  </script>
  <style scoped>
.selected-accounts-scroll {
  max-height: 250px;
  overflow-y: auto;
}
</style>
<style scoped>
.custom-task-list {
  max-height: 35vh;
  min-width: 100%;
  overflow: scroll;
  z-index: var(--z-overlay) !important;
  width: 20vh;
}
</style>
<style>
.information-manager-fixed-tooltip.v-tooltip__content {
  z-index: var(--z-tooltip);
}
</style>
  